module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', [_c('div', {
    staticClass: "top-header"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-2 b2"
  }, [_vm._v("\n              SGS Now\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 font-size-12px"
  }, [_c('ul', {
    staticClass: "menu-1"
  }, [_c('li', {
    staticClass: "padding-right-10px"
  }, [_c('a', {
    attrs: {
      "href": "http://www.sgsgroup.com.br"
    }
  }, [_vm._v(_vm._s(_vm.$t('sgsHome')))])]), _vm._v(" "), _c('li', {
    staticClass: "border-left-1px padding-left-10px"
  }, [_c('a', {
    attrs: {
      "href": "http://www.sgs.com"
    }
  }, [_vm._v(_vm._s(_vm.$t('sgsAroundTheWorld')))])]), _vm._v(" "), _c('li', {
    staticClass: "border-left-1px padding-left-10px"
  }, [_c('a', {
    attrs: {
      "href": "http://www.sgs.com/en/office-directory"
    }
  }, [_vm._v(_vm._s(_vm.$t('contactUs')))])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4 font-size-12px"
  }, [_c('MenuUser')], 1)])])])])]), _vm._v(" "), _c('nav', {
    staticClass: "navbar border-sgs"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-2"
  }, [_c('Brand')], 1), _vm._v(" "), (_vm.isLogged) ? _c('div', {
    staticClass: "col-sm-10"
  }, [_c('ul', {
    staticClass: "menu root"
  }, [_c('router-link', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showBusinessLine),
      expression: "showBusinessLine"
    }],
    attrs: {
      "to": {
        name: 'BusinessAreaList'
      },
      "tag": "li",
      "exact": ""
    }
  }, [_c('a', [_vm._v(_vm._s(_vm.$t("businessLine")))])]), _vm._v(" "), _c('router-link', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showContracts),
      expression: "showContracts"
    }],
    attrs: {
      "to": {
        name: 'SystemsList'
      },
      "tag": "li",
      "exact": ""
    }
  }, [_c('a', [_vm._v(_vm._s(_vm.$t("contracts")))])])], 1), _vm._v(" "), (_vm.contractMenuShow) ? _c('subMenu') : _vm._e()], 1) : _vm._e()])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-30bc98c6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/root/header/MenuNoResponsive.vue
// module id = 908
// module chunks = 2